export const formatJurisdictionLabel = (jurisdiction) => {
  if (!jurisdiction) return "Jurisdiction not set";
  if (typeof jurisdiction === "string") return jurisdiction;
  const country = jurisdiction.country || "";
  const region = jurisdiction.region_or_state || "";
  if (!country && !region) return "Jurisdiction not set";
  return region ? `${country} - ${region}` : country;
};

export { formatNumberWithCommas, formatPercent } from "./numberUtils";
